export { SlideFavoriteButton } from "#slide-favorite-button";
